import get from 'lodash/get';
import { REDUCERS_NAME } from '../../constants';

const reducerName = REDUCERS_NAME.NOTIFICATIONS;

export const selectNotifications = (state) => get(state, `${reducerName}.data`);
export const selectNotificationsLoader = (state) => get(state, `${reducerName}.loader`);
export const selectNotificationsError = (state) => get(state, `${reducerName}.error`);
